(function () {

  var $videos = document.querySelectorAll('.js-video');
  if ($videos.length) {
    $videos.forEach(function($video) {

      $video.querySelector('.js-video-btn').addEventListener('click', function() {
        var url = $video.getAttribute('data-video');
        var player = document.createElement("IFRAME");
        player.setAttribute('width', '640');
        player.setAttribute('height', '360');
        player.setAttribute('frameborder', 0);
        player.setAttribute('allow', 'autoplay; fullscreen; picture-in-picture');
        player.setAttribute('src', url);
        $video.innerHTML = '';
        $video.append(player);
      });

    });
  }

})();
